import styled from "styled-components";

const StyledTitle = styled.h1`
    font-size: 24px;
    color: #1e1e1e;
    font-weight: 700;
`;

const StyledDiv = styled.div`
    display: flex;
    justify-content: center;
    margin: 40px 0;
`;

const StyledButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

export { StyledTitle, StyledDiv, StyledButtonContainer };
